import {SET_ROUTER_HISTORY} from '../constants';

export function setRouterHistory(history) {
    return {
        type: setRouterHistory(),
        payload: history
    };
}
